import PropTypes from 'prop-types';

const AboutUs = ({data}) => {
  return (
    <div className={'w-full flex  flex-col justify-center items-center lg:px-24 px-5 lg:py-10 py-4 bg-primary-950'}>
     
      {/* Our Design Approach */}
      <div>
        <div className={'flex justify-start w-full'}>
          <h1 className={'playfair-display-medium font-bold lg:text-6xl text-3xl text-secondary-300'}>Our Design Approach</h1>
        </div>
        <div className={'grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 lg:mt-10 mt-8 max-w-7xl'}>
          {data.cards.map((card, index) => (
            <div key={index} className={'card p-6 shadow-md rounded-3xl bg-primary-500'}>
              <img src={card.image} alt={card.title} className={'w-full lg:h-56 h-60 object-cover mb-5 rounded-xl'} />
              <p className={'text-justify text-base font-sans'}>{card.description}</p>
            </div>
          ))}
        </div>

        {/* Why Choose Us */}
        <div className={'flex justify-start w-full'}>
          <h1 className={'playfair-display-medium font-bold lg:text-6xl text-3xl lg:mt-10 mt-8 text-secondary-300'}>Why Choose Us</h1>
        </div>
        <div className={'grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 lg:mt-10 mt-8 max-w-7xl'}>
          {data.cards1.map((card, index) => (
            <div key={index} className={'card p-6 shadow-md rounded-3xl bg-primary-500'}>
              <img src={card.image} alt={card.title} className={'w-full lg:h-56 h-60 object-cover mb-5 rounded-xl'} />
              <h2 className={'text-2xl font-extrabold mb-2 prata'}>{card.title}</h2>
              <p className={'text-justify text-base font-sans'}>{card.description}</p>
            </div>
          ))}
        </div>

        {/* Our story */}
        <h1 className={'w-full text-start playfair-display-medium font-bold lg:text-6xl text-3xl mt-10 text-secondary-300'}>{data.title}</h1>
        <div className={'grid lg:grid-cols-2  grid-cols-1 lg:gap-10 gap-5 lg:mt-10 mt-7 max-w-7xl'}>
          <div className={'lg:h-80 md:h-96 h-80 w-full'}>
            <img src={data.image} alt={'home'} className={'object-cover w-full h-full rounded-xl'}></img>
          </div>
          <div className={'flex flex-col justify-center'}>
            <h1 className={'playfair-display-medium font-bold lg:text-4xl text-4xl text-secondary-300'}>{data.title1}</h1>
            <p className={'lg:mt-3 md:mt-2 mt-5 font-sans text-xl text-justify'}>{data.description}</p>
          </div>  
        </div> 
      </div>
      <div>        
      </div>
    </div>
  );
};

AboutUs.propTypes = {
  data: PropTypes.shape,
};

export default AboutUs;
